/** @jsxImportSource @emotion/react */
import React from "react";
import type { TabsProps } from "antd";
import { TabsComponent } from "../../../components/TabsComponent";
import { AppHomepageList } from "./app-homepage/AppHomepageList";
import { CtasList } from "./ctas/CtasList";
import { useLocation } from "react-router-dom";
import { PageWrapper } from "../../../components/page-skeleton/PageWrapper";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const AppHome = () => {
  const query = useQuery();
  const defaultOpenTab = query.get("key");
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: `Homepages`,
      children: <AppHomepageList />,
    },
    {
      key: "2",
      label: `Call to actions`,
      children: <CtasList />,
    },
  ];

  return (
    <PageWrapper>
      <TabsComponent defaultActiveKey={`${defaultOpenTab}`} items={items} />
    </PageWrapper>
  );
};
